import { useSelector } from "react-redux";
import { AppState } from "store";
// #region types
// #endregion
// #region components
import { useCheckRelations } from "components/common";
import { useDocumentPermissions } from "components/documents";
// #endregion

function useAnnualAccountPermissions() {
  const { getIsRevisor } = useCheckRelations();
  const { getIsBoard } = useCheckRelations();
  const hasSavedFinancialStatements = useSelector(
    (state: AppState) => state.auth.selectedCompany.hasSavedFinancialStatements
  );
  const { hasDocumentPermissions } = useDocumentPermissions();

  const getHasFinancialStatementPermissions = () => {
    return hasDocumentPermissions && hasSavedFinancialStatements;
  };

  const getHasAnnualAccountDocumentPermission = () => {
    return hasDocumentPermissions || getIsRevisor() || getIsBoard();
  };

  return {
    getHasFinancialStatementPermissions,
    getHasAnnualAccountDocumentPermission,
  };
}

export default useAnnualAccountPermissions;
